export const STREAM_STATUS = new Set([
  'Starting stream...',
  'Writing answer...',
  'Thinking…',
  'Working on your request',
])

export const TERMINAL_SUMMARIES = new Set([
  'Response ready',
  'Document ready',
  'Work completed',
  'Steps reported complete',
  'Stream failed',
  'Answer incomplete',
  'Response interrupted',
])
